// import { mapGetters } from 'vuex'

export default {
  props: {
    control: {
      required: true,
      type: Object
    }
    // id: {
    //   required: true,
    //   type: String | Number
    // }
  },
  // computed: {
  //   ...mapGetters('Questionnaires', [
  //     'control'
  //   ]),
  //   input () {
  //     return this.control(this.id)
  //   }
  // },
  created () {
    this.$emit('on-create', this.editPanel)
  }
}
